import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, map, catchError } from 'rxjs/operators';
import { of, from } from 'rxjs';
import {
  searchForCurateSearchAction,
  searchForCurateSearchActionSuccess,
  getCurateSearchOptionsAction,
  getCurateSearchOptionsActionSuccess,
} from './curate-search-actions';
import { CurateSearchService } from '../../../../../../../../libs/sysque/toolbelt/utils/src/lib/sysque-backend/curate-search.service';

@Injectable()
export class CurateSearchEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly curateSearchService: CurateSearchService
  ) {}

  searchForCurateSearchAction$ = createEffect(() =>
    this.actions$.pipe(
      ofType(searchForCurateSearchAction),
      concatMap((action) =>
        from(this.curateSearchService.getFittingDataByQuery(action.query, action.unitType)).pipe(
          map((response) =>
            searchForCurateSearchActionSuccess({
              response,
              lastCurateSearchQuery: action.query
            })
          ),
          catchError((error) => of(error))
        )
      )
    )
  );

  getCurateSearchOptionsAction$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getCurateSearchOptionsAction),
      concatMap(() =>
        from(this.curateSearchService.getCurateSearchOption()).pipe(
          map((response) => getCurateSearchOptionsActionSuccess({ response })),
          catchError((error) => of(error))
        )
      )
    )
  );
}
